<!-- Main page loader -->
<div *ngIf="isLoading" class="absolute w-full !h-full z-30 top-0 left-0 bottom-0 right-0 animate fast-animation" [class]="!isClosingLoader ? 'animate__fadeIn' : 'animate__fadeOut'">
  <shared-loader [is-loading]="isLoading" [message]="loaderMessage" [isClosing]="isClosingLoader"></shared-loader>
</div>

<!-- Main page container -->
<div class="overflow-auto w-full min-h-full h-auto scroll" [class]="isBlockedBody ? 'overflow-hidden' : ''">

  <!-- Is not valid auth -->
  <div *ngIf="!authorized" class="w-full flex flex-col h-screen">
    <div class="relative w-full h-full">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Is valid auth but not accepted confidentiality notice -->
  <div *ngIf="user && authorized && !user?.noticeConfidentialityAccepted && loadedSettings;" class="w-full flex flex-col h-screen">
    <div class="relative w-full h-full">
      <shared-notice-confidentiality></shared-notice-confidentiality>
    </div>
  </div>

  <!-- Main content for valid auth and accepted confidentiality notice -->
  <main *ngIf="user && authorized && user?.noticeConfidentialityAccepted && loadedSettings" class="w-full flex flex-col h-screen">

    <!-- Notification container -->
    <div *ngIf="notifications.length" class="fixed right-0 overflow-hidden h-fit z-40 mt-10 flex flex-col flex-col-reverse">
      <shared-notification *ngFor="let notification of notifications" [notification]="notification"></shared-notification>
    </div>

    <div class="relative w-full h-full">

      <shared-navbar></shared-navbar>

      <div class="relative w-full h-full">

        <shared-sidebar></shared-sidebar>

        <div class="px-20 pt-10 pb-10 min-h-full h-auto">

          <shared-settings-banner *ngIf="banner === 'Settings'"></shared-settings-banner>

          <shared-viewer *ngIf="isOpenViewer"></shared-viewer>

          <router-outlet #outlet="outlet"></router-outlet>

        </div>

      </div>

    </div>

  </main>

</div>
